module.exports = __webpack_public_path__ + "assets/202509252035/img/mindMap.8a01055d.png";